<template>
  <v-card
    color="blue-grey darken-1"
    dark
    :loading="isUpdating"
  >
    <template v-slot:progress>
      <v-progress-linear
        absolute
        color="green lighten-3"
        height="4"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-img
      height="200"
      src="https://cdn.vuetifyjs.com/images/cards/dark-beach.jpg"
    >
      <v-row>
        <v-col
          class="text-right"
          cols="12"
        >
          <v-menu
            bottom
            left
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="isUpdating = true">
                <v-list-item-action>
                  <v-icon>mdi-settings</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Update</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-row
          class="pa-4"
          align="center"
          justify="center"
        >
          <v-col class="text-center">
             <p class="headline" style="background-color:black;color:yellow;font-size:15px!important;">PÁGINA EM DESENVOLVIMENTO - NÃO DISPONIVEL NO MOMENTO</p>
              <h2 class="headline">Seja Bem vindo Sr. Professor(a) ao serviço publicar súmario</h2>
            <h3 class="headline">{{instituicao }}</h3>
            <span class="grey--text text--lighten-1">{{date}}</span>
          </v-col>
        </v-row>
      </v-row>
    </v-img>
    <v-form>
      <v-container>
        <v-row>
          <v-col col="4">
              <v-select
              v-model="curso"
              item-value="idCurso"
              item-text="descricao"
              @change="loadDisciplinas()"
              @click="loadDisciplinas"
              :items="cursos"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Curso"
            ></v-select>
          </v-col>
          <v-col
            md="4"
          >
            <v-select
              v-model="disciplina"
              item-value="idDisciplina"
              item-text="descricao"
              @change="loadUnidadeComb"
              @click="loadUnidadeComb"
              :items="disciplinasFiltered"
              filled
              color="blue-grey lighten-2"
              label="Disciplina"
            ></v-select>
          </v-col>

          <v-col
            md="4"
          >
            <v-select
               v-model="unidade"
                        item-value="idUnidade"
                        item-text="descricao"
                        @change="loadSumarioComb"
                        @click="loadSumarioComb"
                        :items="unidadesFiltered"
                        :disabled="isUpdating"
                        filled
                        color="blue-grey lighten-2"
                        label="Unidade"
            ></v-select>
          </v-col>

        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-combobox
                        v-model="sumario"
                        item-value="idSumario"
                        item-text="descricao"
                        @change="loadAulaComb"
                        @click="loadAulaComb"
                        :items="sumariosFiltered"
                        :disabled="isUpdating"
                        filled
                        color="blue-grey lighten-2"
                        chips
                        label="Súmario"
                      ></v-combobox>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-combobox
                        v-model="aula"
                        item-value="idAula"
                        item-text="descricao"
                        :items="aulasFiltered"
                        :disabled="isUpdating"
                        filled
                        color="blue-grey lighten-2"
                        chips
                        label="Aulas"
                      ></v-combobox>
          </v-col>
     <!--    <v-col cols="12">
            <v-autocomplete
              v-model="friends"
              :disabled="isUpdating"
              :items="people"
              filled
              chips
              color="blue-grey lighten-2"
              label="Select"
              item-text="name"
              item-value="name"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="remove(data.item)"
                >
                  <v-avatar left>
                    <v-img :src="data.item.avatar"></v-img>
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-avatar>
                    <img :src="data.item.avatar">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>-->
        </v-row>
      </v-container>
    </v-form>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="false"
        :loading="isUpdating"
        color="blue-grey darken-3"
        depressed
        @click="isUpdating = true"
      >
        <v-icon center>mdi-update</v-icon>
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
const fs = require('fs')
const request = require('request')
export default {
  data: () => ({

    insertSumario: [],
    friends: ['Sandra Adams', 'Britta Holt'],
    isUpdating: false,
    instituicao: ls.get('instituicaodescricao'),
    unidadesFiltered: [],
    sumariosFiltered: [],
    cursos: [],
    curso: '',
    aulasFiltered: [],
    disciplinasFiltered: [],
    disciplina: null,
    disciplinas: [],
    unidade: null,
    sumario: null,
    aula: null,
    date: '15-04-2020'
  }),
  watch: {

  },
  created () {
    this.initializeCursos()
    this.initializeDisciplinas()
  },
  methods: {

    remove (item) {
      const index = this.friends.indexOf(item.name)
      if (index >= 0) this.friends.splice(index, 1)
    },
    loadUnidadeComb (disciplina) {
      this.unidadesFiltered = this.unidades.filter(t => t.idDisciplina === this.disciplina)
    },
    loadSumarioComb (unidade) {
      this.sumariosFiltered = this.sumarios.filter(t => t.idUnidade === this.unidade.idUnidade)
    },
    loadAulaComb (sumario) {
      this.aulasFiltered = this.aulas.filter(t => t.idSumario === this.sumario.idSumario)
    },

    async initializeDisciplinaProf () {
      try {
        this.isUpdating = true
        this.disciplinas = await axios
          .get('/disciplinasProf')
          .then(res => res.data)
        this.isUpdating = false
      } catch (error) {
        this.isUpdating = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeDisciplinas () {
      try {
        this.disciplinas = await axios
          .get('/disciplinaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeCursos () {
      try {
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeUnidadeDisciplina () {
      try {
        this.isUpdating = true
        this.unidades = await axios
          .get('/unidadeDisciplina')
          .then(res => res.data)
        this.isUpdating = false
      } catch (error) {
        this.isUpdating = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeSumarioUnidade () {
      try {
        this.isUpdating = true
        this.sumarios = await axios
          .get('/sumarioUnidade')
          .then(res => res.data)
        this.isUpdating = false
      } catch (error) {
        this.isUpdating = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeAulaSumario () {
      try {
        this.isUpdating = true
        this.aulas = await axios
          .get('/aulaSumario')
          .then(res => res.data)
        this.isUpdating = false
      } catch (error) {
        this.isUpdating = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async loadDisciplinas () {
      this.disciplinasFiltered = this.disciplinas.filter(d => d.idCurso === this.curso)
    },

    async insertProfSumario () {
      this.isUpdating = true
      const valor = {
        idInstituicao: ls.get('i_id'),
        idProfessor: ls.get('idPessoa'),
        nomeProfessor: ls.get('nomeUsuario'),
        unidade: this.unidade,
        sumario: this.sumario,
        aula: this.aula
      }
      try {
        this.insertSumario = await axios
          .post('/insertSumario/', valor)
          .then(res => res.data)
        this.isUpdating = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }
  }
}
</script>
